<template>
	<div class="MarkerPopup">
		<div class="MarkerPopup-loading"></div>
		<PlanningPopup v-if="mapType === 'planning'" :data="data"></PlanningPopup>
		<AppointmentPopup v-if="mapType === 'appointments'" :data="data"></AppointmentPopup>
		<MarketingPopup v-if="mapType === 'marketing'" :data="data"></MarketingPopup>
		<QualityPopup v-if="mapType === 'quality'" :data="data" :filter="filter"></QualityPopup>
	</div>
</template>

<script>
import AppointmentPopup from "@/components/markerPopup/AppointmentPopup.vue";
import MarketingPopup from "@/components/markerPopup/MarketingPopup.vue";
import PlanningPopup from "@/components/markerPopup/PlanningPopup.vue";
import QualityPopup from "@/components/markerPopup/QualityPopup.vue";
import {mapState} from "vuex";

export default {
	components: {
		QualityPopup,
		AppointmentPopup,
		PlanningPopup,
		MarketingPopup
	},

	props: {
		data: Object,
		filter: String
	},

	computed: {
		...mapState("map", {
			mapType: "mapType"
		})
	}
};
</script>

<style scoped></style>
